export default "__VITE_ASSET__DzPWnkSX__"